(window => {
  window.Chime = {
    ...window.Chime,
    config: {
      NODE_ENV: process.env.NODE_ENV || '',
      GIT_BRANCH: process.env.CIRCLE_BRANCH || 'unknown',
      GIT_COMMIT_SHA: process.env.CIRCLE_SHA1 || 'none',
      SEGMENT_KEY: process.env.SEGMENT_KEY || '',
      ROLLBAR_TOKEN: process.env.ROLLBAR_TOKEN || '',
      DEPLOYMENT_ENVIRONMENT: process.env.DEPLOYMENT_ENVIRONMENT || 'dev',
      GOOGLE_TAG_MANAGER_KEY: process.env.GOOGLE_TAG_MANAGER_KEY || '',
      PERSONA_ENVIRONMENT: process.env.PERSONA_ENVIRONMENT || '',
      PERSONA_TEMPLATE_ID: process.env.PERSONA_TEMPLATE_ID || '',
      PUBLIC_LCM_PREFILL_KEY: process.env.PUBLIC_LCM_PREFILL_KEY || '',
      OPTIMIZELY_KEY: process.env.OPTIMIZELY_KEY || '',
      OPTIMIZELY_WEB_PROJECT_ID: process.env.OPTIMIZELY_WEB_PROJECT_ID || '',
      SERVER_URL: process.env.SERVER_URL || '',
      SMARTY_KEY: process.env.SMARTY_KEY || '',
      INCODE_CLIENT_ID: process.env.INCODE_CLIENT_ID || '',
      INCODE_API_URL: process.env.INCODE_API_URL || '',
      ARKOSE_PUBLIC_KEY: process.env.ARKOSE_PUBLIC_KEY || '',
      DATADOG_APPLICATION_ID: process.env.DATADOG_APPLICATION_ID || '',
      DATADOG_CLIENT_TOKEN: process.env.DATADOG_CLIENT_TOKEN || '',
      NUDATA_CLIENT_ID: process.env.NUDATA_CLIENT_ID || '',
      DEV_ENV: process.env.DEV_ENV || '',
      ARKOSE_CLIENT_URL:
        process.env.ARKOSE_CLIENT_URL || 'https://arkose-client.chime.com',
      SOCURE_CONFIG_BASE_URL:
        process.env.SOCURE_CONFIG_BASE_URL ||
        'https://socure-proxy.chime.com/device-ingestion',
      SOCURE_PUBLIC_KEY: process.env.SOCURE_PUBLIC_KEY || '',
      CHIME_DOT_COM_URL:
        process.env.CHIME_DOT_COM_URL || 'https://www.chime.com',
    },
  };
})(window);
